// Presentation-only style contract for Field Visit surfaces
// Do NOT import this outside Field Visit-related pages without explicit intent.

export const FV_PAGE_TITLE = "text-lg font-semibold text-slate-100";
export const FV_STEP_KICKER =
  "text-[11px] uppercase tracking-[0.16em] text-slate-400";
export const FV_SECTION_TITLE = "text-sm font-semibold text-slate-100";
export const FV_BODY = "text-[13px] text-slate-200";
export const FV_HELP = "text-[11px] text-slate-400";
export const FV_META = "text-[11px] text-slate-500";
export const FV_CHIP_TEXT = "text-[11px]";

export const FV_PAGE_WRAP = "text-slate-100";
export const FV_CARD = "bg-slate-950/40 border border-slate-800 rounded-md";
export const FV_PANEL = "bg-slate-950/60 border border-slate-800 rounded-md";
export const FV_INSET = "bg-slate-900/40 border border-slate-800 rounded-md";
export const FV_COMMAND_LOG =
  "bg-slate-900/70 border border-slate-700 rounded-md";

export const FV_INPUT =
  "bg-slate-950 border border-slate-700 text-slate-100 text-[13px] placeholder:text-slate-500 focus:border-emerald-500 focus:ring-0";
export const FV_TEXTAREA =
  "bg-slate-900/70 border border-slate-700 text-slate-100 text-[14px] leading-relaxed placeholder:text-slate-500 focus:border-emerald-500 focus:ring-0";

export const FV_BTN_PRIMARY = "bg-emerald-600 hover:bg-emerald-500 text-white";
export const FV_BTN_SECONDARY =
  "border border-slate-700 text-slate-200 hover:bg-slate-900/40";
// For danger, reuse existing red styles from the app where applied.

export const FV_CHIP_NEUTRAL = "border-slate-600 text-slate-300";
export const FV_CHIP_PROGRESS =
  "border-amber-500 text-amber-300 bg-amber-500/10";
export const FV_CHIP_SUCCESS =
  "border-emerald-500 text-emerald-300 bg-emerald-500/10";
export const FV_CHIP_DANGER = "border-red-500 text-red-300 bg-red-500/10";
